import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['clocktower', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-2,-10h1v1h-1zM0,-9.5h0.5v0.5h-0.5zM-2,-9h0.5v2h-0.5zM-1,-9h0.5v0.5h-0.5zM-0.5,-8h0.5v0.5h-0.5zM-2,-7h1v0.5h-1zM0,-7h0.5v0.5h-0.5zM-1,-6.5h1.5v0.5h-1.5zM-2,-6h2v0.5h-2zM-2,-5.5h2.5v0.5h-2.5zM-2,-5h1v2.5h-1zM0,-5h0.5v3h-0.5zM-2,-2.5h1.5v0.5h-1.5zM-2,-2h2.5v0.5h-2.5zM-1,-1.5h1.5v0.5h-1.5zM-2,-1h1.5v0.5h-1.5zM-2,-0.5h2.5v0.5h-2.5zM-0.5,0h1v0.5h-1z',
    },
    {
      paint: [
        ['clocktower', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-0.5,-10h0.5v0.5h-0.5zM1.5,-10h0.5v0.5h-0.5zM-1,-9.5h1v0.5h-1zM0.5,-9.5h1.5v0.5h-1.5zM-1.5,-9h0.5v0.5h-0.5zM0,-9h2v1h-2zM-1,-8.5h0.5v0.5h-0.5zM0.5,-8h1.5v1.5h-1.5zM-0.5,-7.5h0.5v0.5h-0.5zM-1,-7h1v0.5h-1zM0.5,-6.5h1v0.5h-1zM1,-6h1v0.5h-1zM0.5,-5.5h1.5v4h-1.5zM-1,-5h1v0.5h-1zM-0.5,-2.5h0.5v0.5h-0.5zM0.5,-1.5h1v0.5h-1zM1,-1h1v0.5h-1zM0.5,-0.5h1.5v0.5h-1.5zM0.5,0h1v0.5h-1z',
    },
    {
      paint: 'castleRoof',
      d: 'M-1,-13h0.5v0.5h-0.5zM-1.5,-12.5h1v0.5h-1zM-1.5,-12h1.5v0.5h-1.5zM-2,-11.5h2v0.5h-2zM-2.5,-11h2.5v0.5h-2.5zM-2.5,-10.5h3v0.5h-3zM0,-10h0.5v0.5h-0.5zM1,-10h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['castleRoof', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-0.5,-13h0.5v0.5h-0.5zM-0.5,-12.5h1v0.5h-1zM0,-12h1v0.5h-1zM0,-11.5h1.5v0.5h-1.5zM0,-11h2v0.5h-2zM0.5,-10.5h2v0.5h-2zM0.5,-10h0.5v0.5h-0.5z',
    },
    {
      paint: 'clocktower',
      d: 'M-1,-10h0.5v0.5h-0.5zM2,-7h0.5v0.5h-0.5zM-2.5,-6.5h1.5v0.5h-1.5zM1.5,-6.5h1v0.5h-1zM0,-6h1v0.5h-1zM-2,-1.5h1v0.5h-1zM1.5,-1.5h1v0.5h-1zM-0.5,-1h1.5v0.5h-1.5z',
    },
    {
      paint: 'clockFace',
      d: 'M-0.5,-9h0.5v1h-0.5zM-1.5,-8.5h0.5v0.5h-0.5zM-1.5,-8h1v0.5h-1zM-1,-7.5h0.5v0.5h-0.5z',
    },
    { paint: 'shadow', d: 'M-1,-4.5h1v2h-1z' },
    { paint: 'fence', d: 'M0,-8h0.5v1h-0.5zM-1.5,-7.5h0.5v0.5h-0.5z' },
  ],
  pixels: 205,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
